<template>
  <check-base-layout :pagetitle="pagetitle"
                     :checkInfoData="checkFrom">
    <template>
      <check-module :ishow-title="false">
        <el-link type="danger"
                 :underline="false"><i class="el-icon-warning-outline"></i>当前有未成功备货的产品，审批通过后未备货的产品将在入库后释放库存。
        </el-link>
      </check-module>
      <check-module :title="`合同总览`">
        <compart-module :compartData="checkFrom.orderContractBaseOtherPayVo"></compart-module>
      </check-module>
      <check-module :title="`备货信息`">
        <el-row>
          <el-col :span="8">
            <div class="pb20">备货编号：{{orderContractStockup.stockupCode}}</div>
          </el-col>
          <el-col :span="8">
            <div class="pb20">备货方式：{{orderContractStockup.stockupType}}</div>
          </el-col>
          <el-col :span="8">
            <div class="pb20">请求备货时间：{{orderContractStockup.createDate}}</div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <div class="pb20">备货状态：{{orderContractStockup.stockupState | stockupStateFilter}}</div>
          </el-col>
          <el-col :span="8">
            <div class="pb20">预计发货时间：{{orderContractStockup.deliveryTime | dateFilterD}}</div>
          </el-col>
          <el-col :span="8">
            <div class="pb20">备货仓库：{{orderContractStockup.storageName}}</div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <div class="">联系电话：{{orderContractStockup.storagePhone}}</div>
          </el-col>
          <el-col :span="16">
            <div class="">仓库地址：{{orderContractStockup.storageAddress}}</div>
          </el-col>
        </el-row>
      </check-module>
      <check-module
        :tabsdata="tabsdata"
        :activeName="activeTabs"
        @tabclick="tabclick"
        :is-table="true"
      >
        <info-table
          :field-arr="bFieldArr"
          :table-data="bTableData"
          :table-height="`300px`"
        ></info-table>
        <div class="allfield_title">总计</div>
        <info-table
          :field-arr="allFieldArr"
          :table-data="allTableData"
          :table-height="allTableData.length ? `73px` : 'auto'"
        ></info-table>
      </check-module>
    </template>
    <template v-slot:checkFooter>
      <slot name="footer">
        <check-module :title="`审批信息`">
          <check-info-module :checkData="checkFrom.systemFlowRunAuditOrgVos"></check-info-module>
        </check-module>
      </slot>
    </template>
  </check-base-layout>
</template>

<script>
import poMixins from '@/mixin/poMixins'
import checkApi from '@/api/workbench/check'
import { isSuccess } from '@/util/tool'
import { deepClone } from '@/util'
import { releaseStatus, deliverState } from '@/meun/date'

export default {
  name: 'releaseitoryCheck',
  mixins: [poMixins],
  props: {
    pagetitle: {
      type: String,
      default: '释放库存审批'
    }
  },
  data () {
    return {
      releaseStatus,
      activeTabs: 'a',
      allFieldArr: [{
        name: 'cbPrice',
        label: '销售总额'
      }, {
        name: 'cbUnitTotal',
        label: '实际供货总价'
      }],
      bFieldArr: [{
        name: 'brandName',
        label: '品牌'
      }, {
        name: 'seriesName',
        label: '系列'
      }, {
        name: 'proName',
        label: '产品名称'
      }, {
        name: 'proType',
        label: '型号'
      }, {
        name: 'orderNumber',
        label: '订货号'
      }, {
        name: 'stockupCount',
        label: '数量'
      }, {
        name: 'cbUnit',
        label: '单位'
      }, {
        name: 'cbExtimeClass',
        label: '货期',
        formatter (val) {
          if (!val) return '--'
          const d = val.split('-')
          if (d.length !== 2) return val
          return val + '天'
        }
      }, {
        name: 'cbPrice',
        label: '销售报价'
      }, {
        name: 'cbRate',
        label: '毛利率'
      }, {
        name: 'purchaseUnitPrice',
        label: '实际供货单价'
      }, {
        name: 'stockupType',
        label: '备货状态',
        formatter: data => {
          return data
        }
      }, {
        name: 'deliverState',
        label: '发货状态',
        formatter: data => {
          return deliverState[data]
        }
      }],
      tabsdata: [
        {
          label: '释放库存清单',
          name: 'a'
        },
        {
          label: '备货清单',
          name: 'b'
        }
      ],
      checkFrom: {
        orderStockupContentVo: {}
      }
    }
  },

  computed: {
    // 表格数据
    bTableData () {
      if (this.activeTabs === 'b') {
        return this.historyListData
      }
      return this.formatTableData(this.checkFrom.orderContractReleaseContentVoList) || []
    },
    historyListData () {
      return this.formatTableData(this.checkFrom.orderContractStockupCountVoList) || []
    },
    // 总计
    allTableData () {
      if (this.activeTabs === 'b') {
        return [{
          cbPrice: this.checkFrom.historyCbPrice,
          cbUnitTotal: this.checkFrom.historyPurchaseUnitPrice
        }]
      }
      return [{
        cbPrice: this.checkFrom.cbPrice,
        cbUnitTotal: this.checkFrom.purchaseUnitPrice
      }]
    },
    // 备货信息
    orderContractStockup () {
      return this.checkFrom.orderContractStockup || {}
    }
  },
  mounted () {
    this.getReleaseitoryCheckInfo()
  },
  methods: {
    getReleaseitoryCheckInfo () {
      const {
        snaId
      } = this
      checkApi.releaseitoryCheckInfo({
        snaId
      }).then(res => {
        if (isSuccess(res)) {
          this.checkFrom = deepClone(res.data.obj)
          this.$emit('update:data', deepClone(res.data.obj))
        }
      })
    },
    formatTableData (data) {
      if (!data) return []
      return Array.isArray(data) ? data : [data]
    },
    // tab切换
    tabclick (e) {
      this.activeTabs = e
    }
  }
}
</script>

<style scoped lang="less">
  /deep/ .el-icon-warning-outline {
    padding-right: 10px;
  }
</style>
